import { Component } from '@angular/core';

@Component({
    selector: 'loading-arrow-svg',
    templateUrl: './loading-arrow.component.svg',
})
export class LoadingArrowComponent { }
